import React from 'react';
import { motion, AnimatePresence  } from "framer-motion";
import { NotificationStatus } from '../../../interfaces/languages';

export interface INotificationBar{
    show:boolean, 
    notificationStatus: NotificationStatus | null, 
    msg?:string,
    notificationType?: NotificationType | null
}

export enum NotificationType {
    quickTranslate = "QUICKTRANSLATE",
    settings = "SETTINGS"
}

export const defaultSettings:INotificationBar = {show:false, notificationStatus:NotificationStatus.null, msg:"", notificationType:null}

const NotificationBar = ({ show, notificationStatus, msg }: INotificationBar) => {
    if (!show) {
        return <></>
    }
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    id="notificationHub-react">
                        <div className={notificationStatus ?? ""}>{msg}</div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default NotificationBar;